<template>
  <div>
    <div v-if="memberList">
      <div
        v-for="member in memberList"
        :key="member.id"

        class="flex flex-row border-solid border-b-2 border-gray-600 lg:border-gray-300 xs:items-center lg:items-start lg:justify-start pb-4 pt-4 lg:pb-1 lg:pt-1 w-full xs:align-center lg:align-start text-6xl lg:text-base h-32 lg:h-8 cursor-pointer"
      >
        <toggle-button
          v-model="member.participated"
          :height="80"
          :width="190"
          invisible
          :sync="true"
          :value="member.participated"
          class="xs:visible lg:invisible"
          @change="toggleMember(member)"
        />

        <toggle-button
          v-model="member.participated"
          :height="20"
          :width="50"
          invisible
          :sync="true"
          :value="member.participated"
          class="invisible xs:invisible lg:visible"
          @change="toggleMember(member)"
        />

        <p class="w-4 xs:ml-12 lg:ml-2 flex-grow">
          {{ member.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'PresenceMembersList',
    props: {
        sessionId: {
            type: String,
            required: true
        },
        members: {
            type: Array,
            required: true
        },
        playerReviews: {
            type: Array,
            required: false
        }
    },
    data () {
        return {
            connectError: false,
            memberList: []
        }
    },
    mounted () {
        const all = this.members
        this.playerReviews.forEach(function (review) {
            if (review.hasParticipated) {
                const obj = all.find(obj => obj.id === review.player.id)
                console.log(obj + ' particapted!')
                obj.participated = true
            }
        })

        this.memberList = all
    },
    methods: {
        async toggleMember (member) {
            this.connectError = false

            const old = member.participated

            try {
                if (member.participated) {
                    await apiService.setParticipation(this.sessionId, member.id, false, '')
                } else {
                    await apiService.removeParticipation(this.sessionId, member.id, false, '')
                }
            } catch (e) {
                console.log(e)
                console.log('reverting')
                this.connectError = true
                member.participated = old
                const obj = this.members.find(obj => obj.id === member.id)
                obj.participated = false
            }
            this.$forceUpdate()
        }
    }
}
</script>

<style scoped>

</style>